<template>
  <a href="#" @click="clickMethod()" class="ad-text">
    <div class="ad-text__body">
      <p class="ad-text__body__title">{{ titulo }}</p>
      <p class="ad-text__body__text">{{ texto }}</p>
    </div>
    <icono
      class="ad-text__icon" 
      :icon="icono"
      :size="25"
      :style="{color: colorIcono}"></icono>
  </a>
</template>

<script>
  export default {
    props: {
      titulo: String,
      texto: String,
      icono: {
        type: String,
        default: 'mdiCardsHeart'
      },
      colorIcono: {
        type: String,
        default: '#e74c3c'
      },
      clickMethod: {
        type: Function,
        default: function () {
          console.log('click ...')
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ad-text {
    display: block;
    text-align: center;
    background: #ecf0f1;
    color: $color-1;
    padding: 10px;
    border-radius: 10px;
    margin: 10px;
    text-decoration: none;
    position: relative;
    border-bottom: 1px solid #f1c40f;
    border-right: 1px solid #f1c40f;
    &:hover {
      opacity: 0.6;
      cursor: pointer;
    }
    &__body {
      padding: 5px;
      @include desde_hasta($large, $extra-large) {
        padding: 10px;
      }
      @include desde($extra-large) {
        padding: 5px;
      }
      &__title {
        font-family: $ff-1;
        font-size: 16px;
        margin-bottom: 5px;
        font-weight: 600;
        @include desde_hasta($large, $extra-large) {
          font-size: 14px;
        }
        @include desde($extra-large) {
          font-size: 18px;
        }
      }
      &__text {
        font-family: $ff-2;
        font-size: 15px;
        font-weight: 550;
        @include desde_hasta($large, $extra-large) {
          font-size: 12px;
          color: $color-1;
        }
        @include desde($extra-large) {
          font-size: 16px;
        }
      }
    }
    &__icon {
      position: absolute;
      top: 5px;
      left: 5px;
    }
  }
</style>